import React, { useLayoutEffect, useRef, useMemo, useEffect, useState } from 'react';
import classes from './Header.module.css'
import { NavLink, withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Badge, Drawer, IconButton, Toolbar, Typography, Grid } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Aux from '../../../../hoc/AuxComponent'
import { LocationOnOutlined, MailOutlineRounded, PhoneOutlined } from '@material-ui/icons';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    drawer: {
        background: '#333',
    },
    cartTag: {
        position: 'absolute',
        zIndex: '2',
        backgroundColor: '#cc0000',
        top: '40px',
        right: '-16px',
        minWidth: '200px',
        borderRadius: '8px',
        border: '4px solid #cc0000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: '8px',
        paddingRight: '8px',
    },
    cartTagTriangle: {
        borderLeft: '12px solid transparent',
        borderRight: '12px solid transparent',
        borderBottom: '18px solid #cc0000',
        width: '0px',
        height: '0px',
        position: 'absolute',
        zIndex: '1',
        top: -20,
        right: 12,
    },
    carTagText: {
        color: 'white',
    },
    button: {
        color: '#ffc107',
    },
    hoursContainer: {
        margin: 0,
        padding: 0,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        backgroundColor: '#222',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            fontSize: '10px',
            padding: '2px 0',
        },
    },
    hourItem: {
        margin: '0 8px',
        padding: '2px 4px',
        fontSize: '12px',
        color: '#ffc107',
        [theme.breakpoints.down('sm')]: {
            margin: '1px 3px',
            fontSize: '10px',
        },
    },
    mobileHoursContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#222',
        padding: '2px 0',
        maxWidth: '100%',
        fontSize: '10px',
        color: '#ffc107',
        marginTop: 0,
        marginBottom: 0,
    },
    mobileHourItem: {
        margin: '0 2px',
        fontSize: '9px',
        whiteSpace: 'nowrap',
        padding: '0 1px',
        color: '#ffc107',
    }
}));

const Header = (props) => {
    const [active, setActive] = useState(false)
    const MuiClasses = useStyles();
    const theme = useTheme();
    const header = useRef(null);
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [shopOpen, setShopOpen] = useState(props.settings?.isOpen || true);
    const destrucProps = useMemo(() => { return { ...props } }, [props])

    useEffect(() => {
        setShopOpen(props.settings?.isOpen);
    }, [smallScreen, props]);

    const checkDateClosed = (dayNum) => {
        let currentDate = new Date();
        let dayCount = currentDate.getDay();
        let difference = 0;

        for(let i = 0; i < 7; i++){
            if(dayCount === dayNum){
                break;
            }
            else{
                difference++;
                dayCount++;
            }
            if (dayCount > 6){ dayCount = 0 }
        }
        
        let targetDate = new Date(currentDate);
        targetDate.setDate(targetDate.getDate() + difference);
        let returnedDate = moment(targetDate).format('MM/DD');
        
        if(props.datesClosed && props.datesClosed.dates) {
            for (const [key] of Object.entries(props.datesClosed.dates)){
                if(returnedDate === moment(key).format('MM/DD')){
                    return true;
                }
            }
        }
        return false;
    }

    useLayoutEffect(() => {
        if (header.current) {
            destrucProps.setHeaderHeight(header.current.offsetHeight)

            const handleResize = () => {
                destrucProps.setHeaderHeight(header.current.offsetHeight)
            }

            window.addEventListener('resize', handleResize)

            return () => {
                window.removeEventListener('resize', handleResize)
            }
        }
    }, [header, destrucProps]);

    // Handles a mobile bug with unloaded fonts
    document.fonts.ready.then(function () {
        if (header.current)
            destrucProps.setHeaderHeight(header.current.offsetHeight)
    })

    let cart = (
        <Aux>
            {props.cart?.length > 0 ?
                <NavLink to="/cart" className={classes.Link} activeClassName={classes.ActiveLink} onClick={() => props.clearIsAdded()}>
                    <Badge badgeContent={props.cart?.length} color="error">
                        <ShoppingCartIcon />
                        {!smallScreen && props.addedToCart ?
                            <div className={MuiClasses.cartTag}>
                                <Typography variant='h6' className={MuiClasses.carTagText}>New items in cart</Typography>
                                <div className={MuiClasses.cartTagTriangle}></div>
                            </div> : null}
                    </Badge>
                </NavLink> : null}
        </Aux>
    )
    
    let links = (
        <Aux>
            {shopOpen?<NavLink to="/shop" className={classes.Link} activeClassName={classes.ActiveLink}><Typography>SHOP</Typography></NavLink>
            :<small style={{fontSize:'16px', color:'grey'}}><s>SHOP</s> (Closed until Spring)</small>}
            <NavLink to="/equipment" className={classes.Link} activeClassName={classes.ActiveLink}><Typography>USED EQUIPMENT</Typography></NavLink>
            <NavLink to="/services" className={classes.Link} activeClassName={classes.ActiveLink}><Typography>SERVICES</Typography></NavLink>
            <NavLink to="/careers" className={classes.Link} activeClassName={classes.ActiveLink}><Typography>CAREERS</Typography></NavLink>
            <NavLink to="/contact" className={classes.Link} activeClassName={classes.ActiveLink}><Typography>CONTACT</Typography></NavLink>
            <NavLink to="/history" className={classes.Link} activeClassName={classes.ActiveLink}><Typography>HISTORY</Typography></NavLink>
            {props.cart?.length > 0 ?
                <NavLink to="/cart" className={classes.Link} activeClassName={classes.ActiveLink} onClick={() => props.clearIsAdded()}>
                    <Badge badgeContent={props.cart?.length} color="error">
                        <ShoppingCartIcon />
                        {!smallScreen && props.addedToCart ?
                            <div className={MuiClasses.cartTag}>
                                <Typography variant='h6' className={MuiClasses.carTagText}>New items in cart</Typography>
                                <div className={MuiClasses.cartTagTriangle}></div>
                            </div> : null}
                    </Badge>
                </NavLink> : null}
        </Aux>)

    let drawerIcon = <IconButton onClick={() => setActive(true)}><MenuIcon style={{ color: '#ffc107' }} /></IconButton>;

    const renderMobileHours = () => {
        if (!props.settings || props.loading) return null;
    
        return (
            <div className={MuiClasses.mobileHoursContainer}>
                <span className={MuiClasses.mobileHourItem}>
                    <b>S</b>:&nbsp;{checkDateClosed(0) || props.settings.operatingHours.Sunday.closed ? 'CLOSED' : 
                    `${moment(props.settings.operatingHours.Sunday.openTime).format('hA')}-${moment(props.settings.operatingHours.Sunday.closeTime).format('hA')}`}
                </span>
                <span className={classes.mobileDivider}>|</span>
                <span className={MuiClasses.mobileHourItem}>
                    <b>M</b>:&nbsp;{checkDateClosed(1) || props.settings.operatingHours.Monday.closed ? 'CLOSED' : 
                    `${moment(props.settings.operatingHours.Monday.openTime).format('hA')}-${moment(props.settings.operatingHours.Monday.closeTime).format('hA')}`}
                </span>
                <span className={classes.mobileDivider}>|</span>
                <span className={MuiClasses.mobileHourItem}>
                    <b>T</b>:&nbsp;{checkDateClosed(2) || props.settings.operatingHours.Tuesday.closed ? 'CLOSED' : 
                    `${moment(props.settings.operatingHours.Tuesday.openTime).format('hA')}-${moment(props.settings.operatingHours.Tuesday.closeTime).format('hA')}`}
                </span>
                <span className={classes.mobileDivider}>|</span>
                <span className={MuiClasses.mobileHourItem}>
                    <b>W</b>:&nbsp;{checkDateClosed(3) || props.settings.operatingHours.Wednesday.closed ? 'CLOSED' : 
                    `${moment(props.settings.operatingHours.Wednesday.openTime).format('hA')}-${moment(props.settings.operatingHours.Wednesday.closeTime).format('hA')}`}
                </span>
                <span className={classes.mobileDivider}>|</span>
                <span className={MuiClasses.mobileHourItem}>
                    <b>Th</b>:&nbsp;{checkDateClosed(4) || props.settings.operatingHours.Thursday.closed ? 'CLOSED' : 
                    `${moment(props.settings.operatingHours.Thursday.openTime).format('hA')}-${moment(props.settings.operatingHours.Thursday.closeTime).format('hA')}`}
                </span>
                <span className={classes.mobileDivider}>|</span>
                <span className={MuiClasses.mobileHourItem}>
                    <b>F</b>:&nbsp;{checkDateClosed(5) || props.settings.operatingHours.Friday.closed ? 'CLOSED' : 
                    `${moment(props.settings.operatingHours.Friday.openTime).format('hA')}-${moment(props.settings.operatingHours.Friday.closeTime).format('hA')}`}
                </span>
                <span className={classes.mobileDivider}>|</span>
                <span className={MuiClasses.mobileHourItem}>
                    <b>S</b>:&nbsp;{checkDateClosed(6) || props.settings.operatingHours.Saturday.closed ? 'CLOSED' : 
                    `${moment(props.settings.operatingHours.Saturday.openTime).format('hA')}-${moment(props.settings.operatingHours.Saturday.closeTime).format('hA')}`}
                </span>
            </div>
        );
    };

    // Desktop hours display
    const renderDesktopHours = () => {
        if (!props.settings || props.loading) return null;
        
        return (
            <Grid container className={MuiClasses.hoursContainer}>
                <Grid item className={MuiClasses.hourItem}>
                    <Typography variant="subtitle2"><b>Sun</b>:&nbsp;
                        {checkDateClosed(0) || props.settings.operatingHours.Sunday.closed ? 'CLOSED' :
                        `${moment(props.settings.operatingHours.Sunday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Sunday.closeTime).format('hA')}`}
                    </Typography>
                </Grid>
                <Grid item className={MuiClasses.hourItem}>
                    <Typography variant="subtitle2"><b>Mon</b>:&nbsp;
                        {checkDateClosed(1) || props.settings.operatingHours.Monday.closed ? 'CLOSED' :
                        `${moment(props.settings.operatingHours.Monday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Monday.closeTime).format('hA')}`}
                    </Typography>
                </Grid>
                <Grid item className={MuiClasses.hourItem}>
                    <Typography variant="subtitle2"><b>Tue</b>:&nbsp;
                        {checkDateClosed(2) || props.settings.operatingHours.Tuesday.closed ? 'CLOSED' :
                        `${moment(props.settings.operatingHours.Tuesday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Tuesday.closeTime).format('hA')}`}
                    </Typography>
                </Grid>
                <Grid item className={MuiClasses.hourItem}>
                    <Typography variant="subtitle2"><b>Wed</b>:&nbsp;
                        {checkDateClosed(3) || props.settings.operatingHours.Wednesday.closed ? 'CLOSED' :
                        `${moment(props.settings.operatingHours.Wednesday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Wednesday.closeTime).format('hA')}`}
                    </Typography>
                </Grid>
                <Grid item className={MuiClasses.hourItem}>
                    <Typography variant="subtitle2"><b>Thu</b>:&nbsp;
                        {checkDateClosed(4) || props.settings.operatingHours.Thursday.closed ? 'CLOSED' :
                        `${moment(props.settings.operatingHours.Thursday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Thursday.closeTime).format('hA')}`}
                    </Typography>
                </Grid>
                <Grid item className={MuiClasses.hourItem}>
                    <Typography variant="subtitle2"><b>Fri</b>:&nbsp;
                        {checkDateClosed(5) || props.settings.operatingHours.Friday.closed ? 'CLOSED' :
                        `${moment(props.settings.operatingHours.Friday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Friday.closeTime).format('hA')}`}
                    </Typography>
                </Grid>
                <Grid item className={MuiClasses.hourItem}>
                    <Typography variant="subtitle2"><b>Sat</b>:&nbsp;
                        {checkDateClosed(6) || props.settings.operatingHours.Saturday.closed ? 'CLOSED' :
                        `${moment(props.settings.operatingHours.Saturday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Saturday.closeTime).format('hA')}`}
                    </Typography>
                </Grid>
            </Grid>
        );
    };

    return (
        <div>
            <AppBar style={{ background: '#333' }} ref={header} id='header-appbar'>
                <Toolbar style={{ paddingBottom: 0 }}>
                    <div className={classes.Backdrop}>
                        <div className={classes.Header}>
                            {!smallScreen ?    
                                <div className={classes.Info}>
                                    {props.contact?.storePhone ? <div className={classes.InfoItem}><PhoneOutlined style={{ fontSize: 14 }} /><a href={"tel:+1" + props.contact.storePhone.replace(/-/gi, '')}>{props.contact.storePhone}</a></div> : null}
                                    {props.contact?.email ? <div className={classes.InfoItem}><MailOutlineRounded style={{ fontSize: 14 }} /><a href={"mailto:" + props.contact.email}>{props.contact.email}</a></div> : null}
                                    {props.contact?.location ? <div className={classes.InfoItem} onClick={() => props.history.push('contact')}><LocationOnOutlined style={{ fontSize: 14 }} />{props.contact.location}</div> : null}
                                </div>
                                : <div className={classes.Info}>
                                    {props.contact?.storePhone ? <div className={classes.InfoItem}><PhoneOutlined style={{ fontSize: 20 }} /><a href={"tel:+1" + props.contact.storePhone.replace(/-/gi, '')}> </a></div> : null}
                                    {props.contact?.email ? <div className={classes.InfoItem}><MailOutlineRounded style={{ fontSize: 20 }} /><a href={"mailto:" + props.contact.email}> </a></div> : null}
                                    {props.contact?.location ? <div className={classes.InfoItem} onClick={() => props.history.push('contact')}><LocationOnOutlined style={{ fontSize: 20 }} /> </div> : null}
                                </div>}
                            <div className={classes.LogoInfo}>
                                {!smallScreen ?
                                    <div className={classes.LogoContainer}>
                                        <NavLink to="/" className={classes.Logo}>Gee Tee Holdings Inc.  </NavLink>
                                    </div>
                                    : 
                                    <div className={classes.LogoContainer}>
                                        <NavLink to="/" className={classes.Logo}>Gee Tee <br></br>Holdings Inc. </NavLink>
                                        <small style={{ color: '#c00000', textShadow: '1px 1px black, 2px 2px black' }}>{process.env.NODE_ENV === 'development' && "DEVELOPER MODE"}</small>
                                    </div> }
                                    {!smallScreen ?
                                        <p style={{ color: '#c00000', textShadow: '1px 1px black, 2px 2px black' }}>{process.env.NODE_ENV === 'development' && "DEV MODE"}</p>
                                        : null }
                            </div>
                            <div className={classes.InlineInfo}>
                                {props.contact?.storePhone ?<div className={classes.InfoItem}><PhoneOutlined style={{ fontSize: 14 }} /><a href={"tel:+1" + props.contact.storePhone.replace(/-/gi, '')}>{props.contact.storePhone}</a></div>: null}
                                {props.contact?.storePhone ?<div className={classes.InfoItem}><MailOutlineRounded style={{ fontSize: 14 }} /><a href={"mailto:" + props.contact.email}>{props.contact.email}</a></div>: null}
                                {props.contact?.location ?<div className={classes.InfoItem} onClick={() => props.history.push('contact')} ><LocationOnOutlined style={{ fontSize: 14 }} />{props.contact.location}</div>: null}
                            </div>
                            <div className={classes.NavOptions}>
                                {smallScreen ? drawerIcon : links}
                                {smallScreen ? cart : null}
                            </div>
                        </div>
                    </div>
                </Toolbar>
                
                {smallScreen ? (
                    renderMobileHours()
                ) : (
                    <div style={{ width: '100%', margin: 0, padding: 0 }}>
                        {renderDesktopHours()}
                    </div>
                )}
            </AppBar>
            

            
            <Drawer anchor='left' open={active} onClick={() => setActive(false)} onClose={() => setActive(false)} classes={{ paper: MuiClasses.drawer }}>
                {links}
            </Drawer>
        </div>
    );
};

export default withRouter(Header);